import { ISelectedAccountController } from '@ambire-common/interfaces/selectedAccount'
import useController from '@common/hooks/useController'

// Native: bypass *ControllerStateProvider (web-only context); read directly
// from the in-process ControllerStore via useController.
export default function useSelectedAccountControllerState(): ISelectedAccountController {
  const { state } = useController('SelectedAccountController')
  return state as ISelectedAccountController
}
